import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const RouteReadOnlyIconIcon = (props) => {
  const {className, visible} = props;

  if (!visible) {
    return null;
  }

  return (
    <i
      className={classnames(
        "RouteReadOnlyIconIcon",
        "fa fa-lock",
        "text-info",
        className,
      )}
      title="Route can't be modified" />
  );
};

RouteReadOnlyIconIcon.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
};

export default RouteReadOnlyIconIcon;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RouteReadOnlyIcon.js
 **/